module.exports = __webpack_public_path__ + "static/media/commute-daqri.98128751.png";